import { ReactNode } from "react";
import Loader from "./Loader";

interface LiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  className?: string;
  children?: ReactNode;
  handleClick?: () => void;
  buttonText?: string;
  instantMeeting?: boolean;
  image?: string;
  buttonClassName?: string;
  buttonIcon?: string;
  loader?: boolean;
}

const LiveModal = ({
  isOpen,
  onClose,
  title,
  className,
  children,
  handleClick,
  buttonText,
  image,
  buttonClassName,
  buttonIcon,
  loader,
}: LiveModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-30"
      onClick={onClose}
    >
      <div
        className="bg-[#EBEBEB] text-[#134F98] w-[100%] max-w-[520px] p-8 rounded-lg flex flex-col gap-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex flex-col items-center gap-8">
          {image && (
            <div className="rounded-full overflow-hidden">
              <img
                className="object-contain w-[100px] h-[100px]"
                src={image}
                alt="checked"
              />
            </div>
          )}
          <h1
            className={`text-2xl font-[600] text-center leading-tight ${className}`}
          >
            {title}
          </h1>
        </div>

        {/* Modal Body */}
        <div className="modal-body">{children}</div>

        {/* Modal Button */}
        <button
          className={`bg-blue-600 text-white px-4 py-3 rounded-md text-center text-base font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 ${buttonClassName}`}
          onClick={handleClick}
        >
          {buttonIcon && (
            <img src={buttonIcon} alt="button icon" width={13} height={13} />
          )}
          {loader ? <Loader /> : buttonText}
        </button>
      </div>
    </div>
  );
};

export default LiveModal;
